<template>
  <v-card>
    <v-card-title> {{ editMode ? "Edit" : "Add New" }} Repository </v-card-title>
    <v-card-text>
      <v-form ref="frmRepo" v-model="valid" lazy-validation class="form-inputs">
        <v-row>
          <v-col cols="12" xs="12" md="6" sm="12">
            <AutoCompleteField
              :items="commitmentsObject"
              item-title="Name"
              item-value="id"
              v-model="model.commitmentId"
              :rules="[rules.required]"
              label="Commitment"
              placeholder="Commitment"
              outlined
            />
          </v-col>
          <v-col cols="12" xs="12" md="12" sm="12">
            <TextField
              :disabled="editMode"
              :rules="[rules.required, rules.httplink]"
              v-model="model.httpsLink"
              label="Https Link"
              placeholder="Https Link"
              outlined
            />
          </v-col>
          <v-col cols="12" xs="12" md="12" sm="12">
            <TextField
              :rules="[rules.required, rules.EmailCheck]"
              v-model="model.userName"
              label="Git Username"
              placeholder="Git Username"
              outlined
            />
          </v-col>
          <v-col cols="12" xs="12" md="12" sm="12">
            <TextField
              :rules="[rules.required]"
              v-model="model.personalAccessToken"
              label="Personal Access Token"
              placeholder="Personal Access Token"
              outlined
            />
          </v-col>
          <v-col cols="12" xs="12" md="12" sm="12">
            <DateInputField label="Date" first-day-of-week="1" v-model="model.expiryDate" hide-actions placeholder="Date" prepend-icon="" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-col md="12">
        <v-btn :loading="registerLoading" color="secondary" class="mr-5" dark @click="save"><v-icon>mdi-check</v-icon> Save</v-btn>
        <v-btn :disabled="registerLoading" text color="primary" dark @click="cancel"> cancel</v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { TeammemberRepositoryVM } from "../../viewModels/response/repository/TeammemberRepositoryVM";
import Project from "../../models/Project";
import TextField from "../Fields/TextField.vue";
import AutoCompleteField from "../Fields/AutoCompleteField.vue";
import DateInputField from "../Fields/DateInputField.vue";
import rules from "../../utils/validations";

export default defineComponent({
  components: {
    TextField,
    AutoCompleteField,
    DateInputField,
  },
  props: ["repoModel", "commitments", "registerLoading"],
  data() {
    return {
      rules,
      valid: null,
      expiryDatePicker: false,
      editMode: false,
      commitmentsObject: this.commitments,
      model: {
        Id: this.repoModel.Id ? this.repoModel.Id : "",
        repositoryName: this.repoModel.RepositoryName,
        httpsLink: this.repoModel.HttpsLink,
        userName: "",
        personalAccessToken: "",
        commitmentId: this.repoModel.commitmentId,
        commitmentName: "",
        expiryDate: this.repoModel.ExpiryDate ? new Date(this.repoModel.ExpiryDate) : null,
        commits: this.repoModel.Commits,
      },
    };
  },
  methods: {
    convertProjectIdToPrject(projectId: any) {
      return {
        id: projectId,
      } as Project;
    },
    async save() {
      try {
        const isValid = await (this.$refs.frmRepo as any).validate();
        if (isValid.valid) {
          const teammemberRepositoryModel = {
            RepositoryHttpsLink: this.model.httpsLink,
            PersonalAccessToken: this.model.personalAccessToken,
            RepositoryName: this.model.userName,
            UserName: this.model.userName,
            ExpiryDate: this.model.expiryDate,
            CommitmentId: this.model.commitmentId,
            CommitmentName: "",
          } as TeammemberRepositoryVM;

          // add/edit To Repositories collection
          await this.$emit("saved", teammemberRepositoryModel);
        }
      } catch (error) {
        this.$emit("closeEdit", "Couldn't Update The Repository!");
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  async mounted() {
    this.editMode = false;
    if (this.repoModel) {
      this.editMode = this.repoModel.RepositoryHttpsLink ? true : false;
      this.model.personalAccessToken = this.repoModel.PersonalAccessToken;
      this.model.userName = this.repoModel.UserName;
      this.model.repositoryName = this.repoModel.RepositoryName;
      this.model.httpsLink = this.repoModel.RepositoryHttpsLink;
      this.model.commitmentId = this.repoModel.CommitmentId;
      this.model.commitmentName = this.repoModel.CommitmentName;
    }
  },
});
</script>
